import { PickupAbility, PickupConfig } from "../GameConfig/PickupConfig.js";

export default class Pickup {
  constructor() {
    this.image = new Image();

    this.speed = PickupConfig.SPEED;

    this.x = PickupConfig.INITIAL_X_POS_PX;
    this.y = 200;

    this.markedForDeletion = false;
    this.pickedUpByPlayer = false;
    this.timer = 0;
  }
  draw(context) {
    context.drawImage(this.image, this.x, this.y);
  }
  update(deltaTime, player) {
    this.x += this.speed;
    if (this.x < -this.spriteWidth) {
      this.markedForDeletion = true;
    }

    if (
      player.ability.has(PickupAbility.SHIELD) ||
      player.ability.has(PickupAbility.TURRET)
    ) {
      this.timer += deltaTime;
    }

    if (this.timer > this.totalTime) {
      player.ability.delete(this.ability);
      this.markedForDeletion = true;
    }
  }
}
